import { apiClient } from "@api/client";
import { requestVoid } from "@api/request";

/**
 * TODO(BE-1951): TEMPORARY — first-clinic launch only; delete with src/complaints/.
 *
 * Direct complaint channel (WEB-3201 / BE-1926): one POST carrying the practice
 * manager's verbatim message to brian, which packages it with recent clinic context
 * and alerts the team. Throwaway, single-clinic, deliberately minimal.
 *
 * `POST /complaints` isn't in the generated OpenAPI schema yet, so the typed client
 * can't know the path. The cast is confined to this call site and goes away when the
 * schema is regenerated; the request still flows through `apiClient`, so the auth /
 * refresh middleware applies.
 */

type UntypedPost = (
  url: string,
  init: { body: unknown },
) => Promise<{ data?: unknown; response: Response }>;

export const complaintsClient = {
  /** File a complaint; resolves on 2xx, throws ClinicAuthError otherwise. */
  file: (message: string): Promise<void> =>
    requestVoid(() =>
      (apiClient.POST as unknown as UntypedPost)("/complaints", {
        body: { message },
      }),
    ),
};
